
export const CONFIG = {
    default_lang:  'fr',
    calculator: 'lwlp',
    // api: 'http://localhost:8888/myair.france-air.com/htdocs/api/v1'
    api: 'https://myair.france-air.com/api/v1'
};
